<div [ngClass]="!(isAuthenticated() | async) ? 'container m--margin-top-100' : ''">
  <app-profile-audit type="profile"></app-profile-audit>
</div>

<div class="demo-info" *ngIf="(demoState | async).profileDetail !== null && ((profileState | async).audit !== null && (profileState | async).audit.status === 0)">
  <div class="row content">
    <div class="demo-avatar col-md-4" *ngIf="(demoState | async).profileDetail !== null">
      <img class="avatar" [src]="(demoState | async).profileDetail.profile_pic_url"/>
    </div>
    <div class="demo-description col-md-4" *ngIf="(demoState | async).profileDetail !== null">
      <h4>Instagram SAMPLE analytics for </h4>
      <h1>&#64;{{(demoState | async).profileDetail.username}}</h1>
    </div>
    <div class="demo-arrow col-md-4">
      <img width="150" src="./assets/images/arrow-bottom.svg"/>
    </div>
  </div>
</div>

<div [ngClass]="!(isAuthenticated() | async) ? 'container' : ''" class="mt-3" *ngIf="(demoState | async).profileDetail !== null && ((profileState | async).audit !== null && (profileState | async).audit.status === 0)">
  <app-profile-audit type="demo"></app-profile-audit>
</div>

<div class="fixed-info text-center p-5" *ngIf="(profileState | async).audit !== null && (profileState | async).audit.status === 0">
  <a class="btn btn-blue btn-blue-hover btn-lg" routerLink="/payment/add">
    <img class="mr-1" src="assets/images/icons/star.png"/>
    View FULL report
  </a>
</div>
